import React from 'react'

import {
  Box,
  Display,
  Col,
  DisplayPosition,
  Grid,
  JustifyContent,
  Image,
  Overflow,
  useTheme,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import { Benefits } from './components/Benefits'
import recipeBox1080webp from '../../assets/HowItWorksSectionAssets/recipe-box-1080.webp'
import recipeBox1400webp from '../../assets/HowItWorksSectionAssets/recipe-box-1400.webp'
import recipeBox1400jpg from '../../assets/HowItWorksSectionAssets/recipe-box-1400.jpg'

import patternNarrowSVG from '../../assets/HowItWorksSectionAssets/egg-pattern-narrow.svg'
import patternWideSVG from '../../assets/HowItWorksSectionAssets/egg-pattern-wide.svg'

export type HowItWorksSectionProps = {
  signupCTA: string
  onCTAClick: () => void
  enableNewHowItWorksCopy?: boolean
}

function HowItWorks({ signupCTA, onCTAClick, enableNewHowItWorksCopy }: HowItWorksSectionProps) {
  const { theme } = useTheme()
  const breakpointFromSmall = `@media (min-width: ${theme.tokens.breakpoints[0]})`
  const breakpointFromLarge = `@media (min-width: ${theme.tokens.breakpoints[2]})`

  const GridWithBackgroundPattern = withCitrusTheme(Grid, () => ({
    backgroundImage: `url(${patternNarrowSVG})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right -20px bottom 280px',
    [breakpointFromSmall]: { backgroundPosition: 'right -90px' },
    [breakpointFromLarge]: {
      backgroundSize: '100% 100%',
      backgroundImage: `url(${patternWideSVG})`,
      backgroundPosition: 'left bottom',
      overflowX: Overflow.Visible,
    },
  }))

  return (
    <section data-testid="howItWorksSection">
      <Box overflowX={Overflow.Hidden}>
        <GridWithBackgroundPattern>
          <Col
            size={[12, null, null, 6]}
            display={Display.Flex}
            paddingV={[14, null, null, 16]}
            paddingBottom={[5, null, null, 16]}
            paddingH={4}
            justifyContent={[null, JustifyContent.Center]}
          >
            <Benefits
              signupCTA={signupCTA}
              onCTAClick={onCTAClick}
              enableNewHowItWorksCopy={enableNewHowItWorksCopy}
            />
          </Col>
          <Col
            size={[12, null, null, 6]}
            position={DisplayPosition.Relative}
            height={['400px', null, null, 'auto']}
            maxHeight="680px"
          >
            <picture>
              <source
                srcSet={recipeBox1080webp}
                media={`(max-width: ${theme.tokens.breakpoints[1]})`}
                type="image/webp"
              />
              <source
                srcSet={recipeBox1400webp}
                media={`(min-width: ${theme.tokens.breakpoints[1]})`}
                type="image/webp"
              />
              <Image
                src={recipeBox1400jpg}
                alt="Open Gousto recipe box containing vegetables, meat, spices, and recipe cards, next to a bowl of creamy tomato sauce pasta cooked recipe."
                width={['100%', null, null, '50vw']}
                height="100%"
                style={{
                  objectFit: 'cover',
                }}
              />
            </picture>
          </Col>
        </GridWithBackgroundPattern>
      </Box>
    </section>
  )
}

export const HowItWorksSection = HowItWorks
